import { useEffect } from 'react'

const SELECTOR = '.scroll-fade-up:not(.in-view)'

export function useFadeInUp() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('in-view')
            }, 50)
            observer.unobserve(entry.target)
          }
        }
      },
      { threshold: 0, rootMargin: '0px 0px -100px 0px' },
    )

    const observeElements = () => {
      for (const el of document.querySelectorAll(SELECTOR)) {
        observer.observe(el)
      }
    }

    const startObserving = () => {
      setTimeout(observeElements, 100)
    }

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', startObserving, { once: true })
    } else {
      startObserving()
    }

    let debounceTimeout: ReturnType<typeof setTimeout>
    const mutationObserver = new MutationObserver(() => {
      clearTimeout(debounceTimeout)
      debounceTimeout = setTimeout(observeElements, 200)
    })

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => {
      observer.disconnect()
      mutationObserver.disconnect()
    }
  }, [])
}
